import { IApplicationContext } from 'shared/common/types/applicationContext';
import { fetchCreateCpdDraft, TCreateCpdDraftResponse } from 'shared/common/repositories/cpd/v1/create-cpd-draft';
import { IPublicV1CreateCpdDraftRequest } from '../../repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';

export async function fetchSaveForm(
  { httpApi }: IApplicationContext,
  parameters: IPublicV1CreateCpdDraftRequest,
): Promise<TCreateCpdDraftResponse> {
  const response: TCreateCpdDraftResponse = await fetchCreateCpdDraft({
    httpApi,
    parameters,
  });

  return response;
}
